import "../../assets/styles/banner.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Link } from "react-router-dom";
import { config } from "../config";
import { useEffect, useState } from "react";
import sliderimg1 from "../../assets/images/sliderimg1.jpg";
import sliderimg2 from "../../assets/images/sliderimg2.jpg";
import sliderimg3 from "../../assets/images/sliderimg3.jpg";
import sliderimg4 from "../../assets/images/sliderimg4.jpg";

const images = [
  sliderimg1,
  sliderimg2,
  sliderimg3,
  sliderimg4,
];
const Banner = () => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % images.length);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    // <section class="hero">
    //   <div class="hero__bg">
    //     {images.map((img, i) => (
    //       <div
    //         key={i}
    //         className={`slide ${i === index ? "active" : ""}`}
    //         style={{ backgroundImage: `url(${img})` }}
    //       />
    //     ))}
    //     {/* <div class="hero__grid"></div> */}
    //   </div>
    //   <div className="overlay"></div>
    //   <div class="hero__content">
    //     <span class="hero__eyebrow">Est. 2017 · Crafted in Gold</span>
    //     <h1 class="hero__title">Where Tradition Meets Elegance</h1>
    //     <p class="hero__sub">Each piece at Maa vaishno jewellers is a symbol of purity,<br />devotion, and timeless beauty.</p>
    //     <div class="hero__actions">
    //       <a href="#collections" class="btn btn--primary">Explore Collections</a>
    //       <Link
    //         to={`${config.appUrl}about-us`}
    //         className="btn btn--ghost"
    //       >Our Story</Link>
    //     </div>
    //   </div>
    //   <div class="hero__jewel">
    //     <div class="jewel-ring">
    //       <div class="jewel-ring__inner"></div>
    //       <div class="jewel-ring__gem"></div>
    //       <div class="jewel-ring__shine"></div>
    //     </div>
    //   </div>
    // </section>

    <Swiper
      modules={[Autoplay]}
      autoplay={{ delay: 3000 }}
      loop={true}
      className="hero-slider"
    >
      <SwiperSlide>
        <div className="hero__content slide1">
          <div className="bg-overlay"></div>
          <span class="hero__eyebrow">Est. 2017 · Crafted in Gold</span>
          <h1 class="hero__title">Where Tradition Meets Elegance</h1>
          <p class="hero__sub">Each piece at Maa vaishno jewellers is a symbol of purity,<br />devotion, and timeless beauty.</p>
          <div class="hero__actions">
            <a href="#collections" class="btn btn--primary">Explore Collections</a>
            <Link
              to={`${config.appUrl}about-us`}
              className="btn btn--ghost"
            >Our Story</Link>
          </div>
        </div>
      </SwiperSlide>

      <SwiperSlide>
        <div className="hero__content1 slide2">
          <div className="bg-overlay"></div>
          {/* <span class="hero__eyebrow">Est. 2017 · Crafted in Gold</span>
          <h1 class="hero__title">Where Tradition Meets Elegance</h1>
          <p class="hero__sub">Each piece at Maa vaishno jewellers is a symbol of purity,<br />devotion, and timeless beauty.</p>
          <div class="hero__actions">
            <a href="#collections" class="btn btn--primary">Explore Collections</a>
            <Link
              to={`${config.appUrl}about-us`}
              className="btn btn--ghost"
            >Our Story</Link>
          </div> */}
        </div>
      </SwiperSlide>

      <SwiperSlide>
        <div className="hero__content1 slide3">
          <div className="bg-overlay"></div>
          {/* <span class="hero__eyebrow">Est. 2017 · Crafted in Gold</span>
          <h1 class="hero__title">Where Tradition Meets Elegance</h1>
          <p class="hero__sub">Each piece at Maa vaishno jewellers is a symbol of purity,<br />devotion, and timeless beauty.</p>
          <div class="hero__actions">
            <a href="#collections" class="btn btn--primary">Explore Collections</a>
            <Link
              to={`${config.appUrl}about-us`}
              className="btn btn--ghost"
            >Our Story</Link>
          </div> */}
        </div>
      </SwiperSlide>
      <SwiperSlide>
        <div className="hero__content1 slide4">
          <div className="bg-overlay"></div>
          {/* <span class="hero__eyebrow">Est. 2017 · Crafted in Gold</span>
          <h1 class="hero__title">Where Tradition Meets Elegance</h1>
          <p class="hero__sub">Each piece at Maa vaishno jewellers is a symbol of purity,<br />devotion, and timeless beauty.</p>
          <div class="hero__actions">
            <a href="#collections" class="btn btn--primary">Explore Collections</a>
            <Link
              to={`${config.appUrl}about-us`}
              className="btn btn--ghost"
            >Our Story</Link>
          </div> */}
        </div>
      </SwiperSlide>
    </Swiper>
  );
};

export default Banner;